import { render, staticRenderFns } from "./ResourcePartner.vue?vue&type=template&id=16478b8c&"
import script from "./ResourcePartner.vue?vue&type=script&lang=js&"
export * from "./ResourcePartner.vue?vue&type=script&lang=js&"
import style0 from "./ResourcePartner.vue?vue&type=style&index=0&id=16478b8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports